import React from "react";
import { Button, Modal } from "react-bootstrap";
import { formatDate } from "../utils/dateUtils";
import S3ImageLoader from "../../../../S3ImageLoader";

export const InvoiceModal = ({ t, show, onHide, invoiceData, onClose, onPrint, pharmacyData }) => {
    if (!invoiceData) return null;
    const isSameState = invoiceData.isSameState;
    const posTaxType = invoiceData.taxType?.toLowerCase() || "gst";
    const isDark = document.body.classList.contains("dark-only");

    return (
        <Modal className="invoice-modal" show={show} onHide={onHide} scrollable centered>
            <Modal.Header>
                <Modal.Title>{t("Invoice Receipt")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div id="invoice-content" className={isDark ? "pos-invoice bg-dark text-white" : "pos-invoice"} style={{ fontSize: "14px" }}>
                    {/* Pharmacy Details */}
                    <div className="text-center mb-2">
                        {pharmacyData?.logo ? (
                            <S3ImageLoader
                                className="m-0"
                                fileName={pharmacyData.logo}
                                style={{ height: "45px", marginBottom: 5 }}
                                alt="profile"
                                fallbackSrc={`${process.env.PUBLIC_URL}/logo.png`}
                            />
                            // <img src={process.env.REACT_APP_IMAGE+pharmacyData.logo} alt="logo" style={{ height: "45px", marginBottom: 5 }} />
                        ) : (
                            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="logo" style={{ height: "40px", marginBottom: 5 }} />
                        )}
                        <p className="mt-1 mb-0 fw-bold ">{pharmacyData?.facility_name}</p>
                        <small className="text-muted">{pharmacyData?.contact_person?.address}</small>
                        <br />
                        <small className="text-muted">
                            {pharmacyData?.contact_person?.city}, {pharmacyData?.contact_person?.country}
                        </small>
                        <br />
                        <small>
                            {t("Tel")}: {pharmacyData?.contact_person?.phone_code} {pharmacyData?.contact_person?.mobile}
                        </small>
                        <br />
                        {pharmacyData?.gstin && (
                            <small className="text-muted">GSTIN: {pharmacyData.gstin}</small>
                        )}
                    </div>

                    {/* Invoice Number and Date */}
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                            <small>
                                {t("Invoice")}: <strong>{invoiceData.invoiceNo}</strong>
                            </small>
                        </div>
                        <div>
                            <small>
                                {formatDate(invoiceData.date)}
                            </small>
                        </div>
                    </div>

                    <div style={{ borderBottom: "1px dotted #000", margin: "6px 0" }} />

                    {/* Customer Details */}
                    <div className="mb-2">
                        <small>
                            {t("Customer")}: <strong>{invoiceData.customer}</strong>
                        </small>
                    </div>

                    {invoiceData.prescribedDoctor?.name && (
                        <div className="mb-2">
                            <small>
                                {t("Prescribed Doctor")}:{" "}
                                <strong>{invoiceData.prescribedDoctor.name}</strong>
                            </small>
                            {invoiceData.prescribedDoctor.contact && (
                                <small className="d-block text-muted">
                                    {invoiceData.prescribedDoctor.contactLabel === "phone" && (
                                        <>{t("Tel")}: {invoiceData.prescribedDoctor.contact}</>
                                    )}
                                    {invoiceData.prescribedDoctor.contactLabel === "email" && (
                                        <>{t("Email")}: {invoiceData.prescribedDoctor.contact}</>
                                    )}
                                    {invoiceData.prescribedDoctor.contactLabel === "clinic" && (
                                        <>{t("Clinic")}: {invoiceData.prescribedDoctor.contact}</>
                                    )}
                                </small>
                            )}
                        </div>
                    )}

                    <div style={{ borderBottom: "1px dotted #000", margin: "6px 0" }} />

                    {/* Items List - Updated to show tax-included total */}
                    <table style={{ width: "100%", fontSize: "12px", lineHeight: "1.3", marginBottom: "10px" }}>
                        <thead>
                            <tr style={{ borderBottom: "1px solid #ddd" }}>
                                <th style={{ width: "45%", textAlign: "left" }}>{t("Item")}</th>
                                <th style={{ width: "10%", textAlign: "center" }}>{t("Qty")}</th>
                                <th style={{ width: "15%", textAlign: "right" }}>{t("Price")}</th>
                                {/* <th style={{ width: "15%", textAlign: "right" }}>{t("Tax")}</th> */}
                                <th style={{ width: "15%", textAlign: "right" }}>{t("Total")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceData.items.map((item, index) => {
                                const price = item.salePrice || 0;
                                const quantity = item.quantity || 1;
                                const itemTax = item.tax || 0;
                                const itemTaxPercentage = item.taxPercentage || 0;
                                const subtotal = price * quantity;
                                const totalWithTax = subtotal; // because subtotal included tax

                                return (
                                    <tr key={`${item._id}-${index}`} style={{ borderBottom: "1px dotted #ddd" }}>
                                        <td style={{ padding: "4px 0", wordBreak: "break-word" }}>
                                            <div style={{ fontWeight: 600 }}>{item.brandName}</div>
                                            {item.batchNumber && (
                                                <div style={{ fontSize: "11px", color: "#666" }}>
                                                    {t("Batch")}: {item.batchNumber}
                                                </div>
                                            )}
                                        </td>
                                        <td style={{ textAlign: "center", padding: "4px 0" }}>
                                            {quantity}
                                        </td>
                                        <td style={{ textAlign: "right", padding: "4px 0" }}>
                                            {invoiceData.currencySymbol}{price.toFixed(2)}
                                        </td>
                                        {/* <td style={{ textAlign: "right", padding: "4px 0" }}>
                                            <div>{itemTaxPercentage}%</div>
                                            <div style={{ fontSize: "11px" }}>
                                                {invoiceData.currencySymbol}{itemTax.toFixed(2)}
                                            </div>
                                        </td> */}
                                        <td style={{ textAlign: "right", padding: "4px 0", fontWeight: 600 }}>
                                            {invoiceData.currencySymbol}{totalWithTax.toFixed(2)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    <div style={{ borderBottom: "1px dotted #000", margin: "10px 0" }} />

                    {/* Totals and Tax Breakdown */}
                    <table style={{ width: "100%", fontSize: "12px" }}>
                        <tbody>
                            {/* Subtotal */}
                            <tr>
                                <td>{t("Total Taxable value")}</td>
                                <td className="text-end">
                                    {invoiceData.currencySymbol}
                                    {invoiceData.subtotal.toFixed(2)}
                                </td>
                            </tr>

                            {/* Discount */}
                            {invoiceData.discount > 0 && (
                                <>
                                    <tr>
                                        <td>
                                            {t("Discount")}
                                            {invoiceData.discountMeta?.type === "Percentage" && (
                                                <span> ({invoiceData.discountMeta.value}%)</span>
                                            )}
                                        </td>
                                        <td className="text-end">
                                            -{invoiceData.currencySymbol}
                                            {invoiceData.discount.toFixed(2)}
                                        </td>
                                    </tr>
                                    {/* Taxable Amount (Discount Applied) */}
                                    <tr>
                                        <td>{t("Net Taxable Amount")}</td>
                                        <td className="text-end">
                                            {invoiceData.currencySymbol}
                                            {(invoiceData.subtotal - invoiceData.discount).toFixed(2)}
                                        </td>
                                    </tr>
                                </>
                            )}


                            {/* Tax Breakdown */}
                            {invoiceData.tax > 0 && (
                                <>
                                    {posTaxType === "gst" ? (
                                        isSameState ? (
                                            <>
                                                {invoiceData.CGST > 0 && (
                                                    <tr>
                                                        <td>CGST ({invoiceData.CGSTPercentage || 0}%)</td>
                                                        <td className="text-end text-success">
                                                            +{invoiceData.currencySymbol}{invoiceData.CGST.toFixed(2)}
                                                        </td>
                                                    </tr>
                                                )}
                                                {invoiceData.SGST > 0 && (
                                                    <tr>
                                                        <td>SGST ({invoiceData.SGSTPercentage || 0}%)</td>
                                                        <td className="text-end text-success">
                                                            +{invoiceData.currencySymbol}{invoiceData.SGST.toFixed(2)}
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        ) : (
                                            invoiceData.IGST > 0 && (
                                                <tr>
                                                    <td>IGST ({invoiceData.IGSTPercentage || 0}%)</td>
                                                    <td className="text-end text-success">
                                                        +{invoiceData.currencySymbol}{invoiceData.IGST.toFixed(2)}
                                                    </td>
                                                </tr>
                                            )
                                        )
                                    ) : (
                                        invoiceData.VAT > 0 && (
                                            <tr>
                                                <td>VAT ({invoiceData.taxPercentage || 0}%)</td>
                                                <td className="text-end text-success">
                                                    +{invoiceData.currencySymbol}{invoiceData.VAT.toFixed(2)}
                                                </td>
                                            </tr>
                                        )
                                    )}

                                    {/* Total Tax */}
                                    <tr className="fw-bold">
                                        <td>{t("Total Tax")}</td>
                                        <td className="text-end fw-bold text-success">
                                            +{invoiceData.currencySymbol}{invoiceData.tax.toFixed(2)}
                                        </td>
                                    </tr>
                                </>
                            )}

                            {/* Grand Total */}
                            <tr className="fw-bold" style={{ borderTop: "2px solid #000", borderBottom: "2px solid #000" }}>
                                <td>{t("Grand Total")}</td>
                                <td className="text-end fw-bold fs-6">
                                    {invoiceData.currencySymbol}{invoiceData.total.toFixed(2)}
                                </td>
                            </tr>

                            {/* Payment Information */}
                            <tr>
                                <td>{t("Paid Amount")}</td>
                                <td className="text-end">
                                    {invoiceData.currencySymbol}{invoiceData.paid.toFixed(2)}
                                </td>
                            </tr>

                            {/* Due Amount or Change */}
                            {invoiceData.total > invoiceData.paid && (
                                <tr>
                                    <td className="fw-bold text-danger">{t("Due Amount")}</td>
                                    <td className="text-end fw-bold text-danger">
                                        {invoiceData.currencySymbol}
                                        {Number(invoiceData.total - invoiceData.paid).toFixed(2)}
                                    </td>
                                </tr>
                            )}

                            {invoiceData.total < invoiceData.paid && (
                                <tr>
                                    <td className="fw-bold text-success">{t("Change Amount")}</td>
                                    <td className="text-end fw-bold text-success">
                                        {invoiceData.currencySymbol}
                                        {Number(invoiceData.paid - invoiceData.total).toFixed(2)}
                                    </td>
                                </tr>
                            )}

                            {/* Fully Paid */}
                            {invoiceData.total === invoiceData.paid && (
                                <tr>
                                    <td colSpan="2" className="text-center text-success fw-bold">
                                        {t("Fully Paid")} ✓
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    <div style={{ borderBottom: "1px dotted #000", margin: "6px 0" }} />

                    {/* Payment Method and Tax Info */}
                    <div className="mt-2">
                        <div className="d-flex justify-content-between">
                            <small>
                                <strong>{t("Payment Method")}:</strong> {invoiceData.paymentType || "Cash"}
                            </small>
                            {/* <small>
                                <strong>{t("Currency")}:</strong> {invoiceData.currency}
                            </small> */}
                        </div>
                        {/* {invoiceData.isSameState !== undefined && (
                            <small className="d-block mt-1">
                                <strong>{t("Tax Type")}:</strong> {posTaxType.toUpperCase()} | 
                                <strong> {t("States")}:</strong> {invoiceData.pharmacyStateCode || "N/A"} 
                                <span className={invoiceData.isSameState ? "text-success ms-1" : "text-danger ms-1"}>
                                    {invoiceData.isSameState ? "=" : "≠"}
                                </span> 
                                {invoiceData.patientStateCode || "N/A"}
                            </small>
                        )} */}
                    </div>

                    {/* Thank You Message and QR Code */}
                    <div className="text-center mt-3">
                        <p style={{ margin: 0 }}>
                            <strong>{t("Thank you for your business")}</strong>
                        </p>
                        <p style={{ margin: 0, fontSize: "11px" }}>
                            {t("Please keep this receipt for warranty purposes")}
                        </p>
                        {invoiceData?.receiptQrData?.qrCodeImage && (
                            <div className="mt-2">
                                <img
                                    src={invoiceData.receiptQrData.qrCodeImage}
                                    alt="QR Code"
                                    style={{ width: "80px", height: "80px" }}
                                />
                                <div>
                                    <small className="text-muted">{t("Scan for digital receipt")}</small>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onPrint}>
                    {t("Print")}
                </Button>
                <Button variant="danger" onClick={onClose}>
                    {t("Close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default InvoiceModal;